import type { QueryClient } from '@tanstack/react-query';

// Story 8.5 — Event emitter SSE → invalida queries TanStack.

export type SseEventType =
  | 'client.created'
  | 'client.updated'
  | 'subscription.created'
  | 'subscription.updated'
  | 'link.awaiting_review'
  | 'link.confirmed'
  | 'payment.confirmed'
  | 'divergence.detected'
  | 'fiscal.invoice.updated'
  | 'heartbeat';

export interface SseEvent<T = unknown> {
  type: SseEventType;
  data: T;
  occurredAt: string;
}

/**
 * Map de eventos SSE → keys de cache TanStack pra invalidar.
 * Quando frontend recebe um evento, invalida todos os queryKeys correspondentes.
 */
const CACHE_INVALIDATIONS: Record<SseEventType, string[][]> = {
  'client.created': [['clients'], ['identities']],
  'client.updated': [['clients'], ['identities']],
  'subscription.created': [['subscriptions']],
  'subscription.updated': [['subscriptions']],
  'link.awaiting_review': [['saas-links'], ['identities']],
  'link.confirmed': [['saas-links'], ['identities']],
  'payment.confirmed': [['charges'], ['dashboard']],
  'divergence.detected': [
    ['dashboard', 'alerts'],
    ['dashboard', 'divergence'],
  ],
  // Story 10.7 AC9 + Wave 1.5 B — webhook Asaas Notas atualiza status de NF
  'fiscal.invoice.updated': [['fiscal']],
  heartbeat: [],
};

export function handleSseEvent(event: SseEvent, qc: QueryClient): void {
  const keys = CACHE_INVALIDATIONS[event.type] ?? [];
  for (const key of keys) {
    qc.invalidateQueries({ queryKey: key });
  }
}
